export default __webpack_public_path__ + "static/media/step_005a.fc4aa064.jpeg";